const dateCharsOnlyRegex = /^[/0-9]*$/;

export default function dateCharsOnly() {
  return (value) => {
    if (!value) return;
    if (!value.match(dateCharsOnlyRegex)) {
      return 'errors.formFields.digits';
    }
  };
}
